
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { BASE_URL, FRONTEND_URL, IMAGE_URL } from '../../config/axios';
import { ToastContainer, toast } from "react-toastify";
import { AppraisalRatingModal, EditAppraisalDetailsByEmployee, UploadAppraisalDetailsByEmployee, ViewAppraisalDetailsByEmployee } from '../AppraisalManagement/AppraisalComponents';
import { handleAllError, CustomImageModal } from '../CustomFunctions';
import usePermission from '../../config/permissions';
import { UpdateEmployeeData } from '../workforcemanagement/components/AddNewEmployeeModel';
import { DeleteDustbin, DownloadIcon, Tripledot, TripledotLarge, UpdatePencil, UpdatePencilWhite } from '../AllSvg';
import ProfileUploadModal from './userDetails-comp/UploadProfile';
import UserDefaultLogo from './UserDefaultLogo';
import { AddBankDetails, BankDetailsWithApprovalRequest } from './UserDetailsComponents';
import { formattedDateLong } from '../Date';


// const Userdetailsmain = ({ email, emp_code }) => {
//   const [formData, setFormData] = useState({})
//   const [appData, setAppData] = useState(null)
//   const [buffer, setBuffering] = useState(true); //buffering logic
//   const { SUB_COMPANIES, SUPER_ADMIN, PORTAL_SETTINGS } = usePermission();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isoptionShow, setIsOptionShow] = useState(false);

//   const profilePicUrl = formData.profilepic ? `${IMAGE_URL}${formData.profilepic}` : null;

//   const toggleModal = () => {
//     setIsModalOpen(!isModalOpen);
//   };

//   const getUSerDetails = async () => {
//     if (!emp_code) return;
//     setBuffering(true);
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`);
//       setFormData(res.data);

//     } catch (err) {
//       handleAllError(err)
//     } finally {
//       setBuffering(false);
//     }
//   };

//   const getApprasalList = async () => {
//     if (!emp_code) return;
//     setBuffering(true); // Start Buffering
//     try {
//       // const res = await axios.get(`${BASE_URL}/wfm/quickAppresalgetbyemp/${emp_code}/`);
//       const res = await axios.get(`${BASE_URL}/wfm/quick-active-appraisaldetails-byemp/${emp_code}/`);
//       setAppData(res.data);

//       if (res.status === 200) {
//         // alert("res200");
//         // setAppData(res.data);
//       }
//       else if (res.status === 400) {
//         // alert("res400");
//         setAppData(null);
//       }
//       // else {
//       //   alert(res);
//       // }
//     } catch (err) {
//       console.log(err)
//       setAppData(null);
//       // handleAllError(err)
//     } finally {
//       setBuffering(false);// End Buffering
//     }
//   };


//   useEffect(() => {
//     if (emp_code) {
//       getUSerDetails();
//       getApprasalList();
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//     }
//   }, [emp_code]);

//   const toggleDisplayOption = () => {
//     setIsOptionShow(!isoptionShow);
//   };


//   const handleDownload = async (e) => {
//     e.preventDefault();

//     if (typeof formData.profilepic === 'string') {

//       const isFullUrl = formData.profilepic.startsWith('http://') || formData.profilepic.startsWith('https://');

//       const profilepicUrl = isFullUrl
//         ? formData.profilepic
//         : `https://cipl-aimantra.s3.ap-south-1.amazonaws.com/${formData.profilepic}`;

//       try {
//         const response = await fetch(profilepicUrl);
//         const blob = await response.blob();

//         const link = document.createElement('a');
//         link.href = URL.createObjectURL(blob);
//         link.download = 'profile-pic.jpg';
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);


//         URL.revokeObjectURL(link.href);
//       } catch (error) {
//         console.error("Download failed:", error);
//       }
//     }
//   };



//   const DeleteProfilePicture = async () => {
//     const loadingToastId = toast.loading("Loading: Please wait...");

//     try {
//       let res = await axios.put(`${BASE_URL}/userdata/userdata/${email}/`, { profilepic: null });

//       if (res.status === 200 || res.status === 201) {
//         await getUSerDetails();
//         toast.success("Profile picture deleted successfully!");
//         setIsOptionShow(false)
//       }
//     } catch (err) {
//       handleAllError(err, loadingToastId)
//     } finally {
//       toast.dismiss(loadingToastId);
//     }
//   };

//   return (
//     <div className='user_main-outer'>

//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//       <div className='user_main'>
//         <div className='user_inner'>
//           <div className='user_inner_style'>

//             <div className="profile-container" style={{ position: 'relative' }}>

//               <CustomImageModal customStyle>
//                 {formData.profilepic ? (
//                   <img
//                     src={profilePicUrl}
//                     alt="profile" className='user_img'
//                   />
//                 ) : (
//                   <UserDefaultLogo user={{ name: formData.name, profilepic: formData.profilepic }} customStyleforParent={"userDetails-logo"} customStyleforChild={"userDetailsChild"} />
//                 )}
//               </CustomImageModal>

//               <div className="" onClick={toggleDisplayOption}>
//                 <TripledotLarge />
//               </div>

//               {isoptionShow && (
//                 <div className="modal-pp modal-profile-modal" style={{ zIndex: '1' }}>
//                   <div className="modal-content-p p-2 rounded-lg shadow-lg bg-white border border-gray-200">
//                     <div className="flex items-center gap-1 flex-column">

//                       {/* <div
//                         className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition"
//                       // onClick={handleLogoChange}
//                       >
//                       <UpdatePencil className="" />
//                         <span className="">Edit</span>
//                       </div> */}
//                       <ProfileUploadModal
//                         // show={viewAvatar}
//                         extra_close={() => setIsOptionShow(false)}
//                         pic={formData}
//                         getUSerDetails={getUSerDetails}
//                         pre_options={true}
//                       />

//                       {formData.profilepic && (
//                         <>
//                           <div
//                             className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition"
//                             onClick={handleDownload}
//                           >
//                             <DownloadIcon className="" color={'black'} />
//                             <span className="">Download</span>
//                           </div>

//                           <div
//                             className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition"
//                             onClick={(e) => DeleteProfilePicture()}
//                           >
//                             <DeleteDustbin className="" />
//                             <span className="">Delete</span>
//                           </div>
//                         </>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               )}

//             </div>

//             <div className={formData.profilepic ? "user_img_box" : "user_img_boxx"} >
//               {formData.designation_name}
//             </div>
//           </div>

//           <div className='user_del'>
//             <div className='user-del--left'>
//               <div>
//                 <h1 className='user_name  user-del--left-title font-weight500 font-size-heading'>{formData.name}</h1>
//               </div>
//               <div>
//                 <p className='user_desg  font-weight500  font-size-heading'>{formData.designation_name} at {formData.division_name}
//                   {buffer ?
//                     <div className="spinner-vsmall"></div>
//                     : SUPER_ADMIN && <UpdateEmployeeData
//                       i={formData}
//                       SubCompany={SUB_COMPANIES}
//                       getAllEmployee={getUSerDetails}
//                       SUPER_ADMIN={SUPER_ADMIN}
//                     />}
//                 </p>
//                 {formData.location_name && (
//                   <div className='user_inner_del font-weight400  font-size-subheading  width-60vw'>
//                     <div className='user_inner_box'>
//                       <svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" viewBox="0 0 14 18" fill="none">
//                         <path d="M7 4C6.38193 4 5.77775 4.18328 5.26384 4.52666C4.74994 4.87004 4.3494 5.3581 4.11288 5.92911C3.87635 6.50013 3.81447 7.12847 3.93505 7.73466C4.05562 8.34085 4.35325 8.89767 4.79029 9.33471C5.22733 9.77175 5.78415 10.0694 6.39034 10.19C6.99653 10.3105 7.62487 10.2486 8.19589 10.0121C8.7669 9.7756 9.25496 9.37506 9.59834 8.86116C9.94172 8.34725 10.125 7.74307 10.125 7.125C10.125 6.2962 9.79576 5.50134 9.20971 4.91529C8.62366 4.32924 7.8288 4 7 4ZM7 9C6.62916 9 6.26665 8.89003 5.95831 8.68401C5.64996 8.47798 5.40964 8.18514 5.26773 7.84253C5.12581 7.49992 5.08868 7.12292 5.16103 6.75921C5.23337 6.39549 5.41195 6.0614 5.67417 5.79917C5.9364 5.53695 6.27049 5.35837 6.63421 5.28603C6.99792 5.21368 7.37492 5.25081 7.71753 5.39273C8.06014 5.53464 8.35298 5.77496 8.55901 6.08331C8.76503 6.39165 8.875 6.75416 8.875 7.125C8.875 7.62228 8.67746 8.09919 8.32583 8.45083C7.97419 8.80246 7.49728 9 7 9ZM7 0.25C5.17727 0.252068 3.42979 0.97706 2.14092 2.26592C0.85206 3.55479 0.127068 5.30227 0.125 7.125C0.125 9.57812 1.25859 12.1781 3.40625 14.6445C4.37127 15.759 5.45739 16.7626 6.64453 17.6367C6.74962 17.7103 6.87482 17.7498 7.00312 17.7498C7.13143 17.7498 7.25663 17.7103 7.36172 17.6367C8.54668 16.7623 9.63069 15.7587 10.5938 14.6445C12.7383 12.1781 13.875 9.57812 13.875 7.125C13.8729 5.30227 13.1479 3.55479 11.8591 2.26592C10.5702 0.97706 8.82273 0.252068 7 0.25ZM7 16.3438C5.70859 15.3281 1.375 11.5977 1.375 7.125C1.375 5.63316 1.96763 4.20242 3.02252 3.14752C4.07742 2.09263 5.50816 1.5 7 1.5C8.49184 1.5 9.92258 2.09263 10.9775 3.14752C12.0324 4.20242 12.625 5.63316 12.625 7.125C12.625 11.5961 8.29141 15.3281 7 16.3438Z" fill="#707070" />
//                       </svg>
//                       <p>{formData.location_name}</p>
//                     </div>
//                   </div>
//                 )}
//               </div>
//               {formData.user_detail && (
//                 <div className='user_inner_box'>
//                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//                     <path d="M17.5 3.75H2.5C2.33424 3.75 2.17527 3.81585 2.05806 3.93306C1.94085 4.05027 1.875 4.20924 1.875 4.375V15C1.875 15.3315 2.0067 15.6495 2.24112 15.8839C2.47554 16.1183 2.79348 16.25 3.125 16.25H16.875C17.2065 16.25 17.5245 16.1183 17.7589 15.8839C17.9933 15.6495 18.125 15.3315 18.125 15V4.375C18.125 4.20924 18.0592 4.05027 17.9419 3.93306C17.8247 3.81585 17.6658 3.75 17.5 3.75ZM15.893 5L10 10.4023L4.10703 5H15.893ZM16.875 15H3.125V5.79609L9.57734 11.7109C9.69265 11.8168 9.84348 11.8755 10 11.8755C10.1565 11.8755 10.3074 11.8168 10.4227 11.7109L16.875 5.79609V15Z" fill="#707070" />
//                   </svg>
//                   <a href={`mailto:${formData.user_detail}`}><p >{formData.user_detail}</p></a>
//                 </div>
//               )}
//               {formData.contact_number && (
//                 <div className='user_inner_box'>
//                   <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
//                     <path d="M17.3727 12.3798L13.6922 10.7306L13.682 10.7259C13.491 10.6441 13.2825 10.6114 13.0756 10.6304C12.8687 10.6495 12.6698 10.7199 12.4969 10.8352C12.4765 10.8487 12.457 10.8633 12.4383 10.879L10.5367 12.5001C9.33204 11.9149 8.08829 10.6806 7.50313 9.49149L9.12657 7.56102C9.14219 7.54149 9.15704 7.52196 9.1711 7.50087C9.28394 7.32845 9.35239 7.13081 9.37039 6.92553C9.38838 6.72026 9.35534 6.51372 9.27423 6.3243V6.31493L7.62032 2.62821C7.51309 2.38076 7.3287 2.17463 7.09468 2.04058C6.86067 1.90654 6.58958 1.85177 6.32188 1.88446C5.26326 2.02376 4.29155 2.54366 3.58824 3.34704C2.88492 4.15042 2.49809 5.18234 2.50001 6.25009C2.50001 12.4532 7.54688 17.5001 13.75 17.5001C14.8177 17.502 15.8497 17.1152 16.6531 16.4119C17.4564 15.7085 17.9763 14.7368 18.1156 13.6782C18.1484 13.4106 18.0937 13.1396 17.9598 12.9056C17.8259 12.6716 17.62 12.4871 17.3727 12.3798ZM13.75 16.2501C11.0987 16.2472 8.55687 15.1927 6.68214 13.318C4.8074 11.4432 3.7529 8.90136 3.75001 6.25009C3.74707 5.48719 4.02192 4.7493 4.52324 4.17423C5.02456 3.59916 5.71806 3.22623 6.47423 3.12509C6.47392 3.1282 6.47392 3.13134 6.47423 3.13446L8.11485 6.80634L6.50001 8.73915C6.48362 8.75801 6.46873 8.77812 6.45548 8.7993C6.33791 8.97971 6.26894 9.18743 6.25525 9.40232C6.24157 9.61722 6.28362 9.83201 6.37735 10.0259C7.08516 11.4735 8.54376 12.9212 10.007 13.6282C10.2023 13.7211 10.4184 13.7617 10.634 13.7461C10.8497 13.7304 11.0576 13.6592 11.2375 13.5391C11.2576 13.5256 11.2769 13.511 11.2953 13.4954L13.1945 11.8751L16.8664 13.5196C16.8664 13.5196 16.8727 13.5196 16.875 13.5196C16.7751 14.2769 16.4027 14.9718 15.8275 15.4743C15.2524 15.9769 14.5138 16.2527 13.75 16.2501Z" fill="#707070" />
//                   </svg>
//                   <a href={`tel:+91${formData.contact_number}`}><p >{formData.contact_number}</p></a>
//                 </div>
//               )}
//             </div>
//             <div className="user-del--right">
//               <div className="" onClick={toggleModal}>
//                 <TripledotLarge />
//               </div>
//               {/* Modal */}
//               {isModalOpen && (
//                 <div className="modal-pp modal-profile-modal">
//                   <div className="modal-content-p p-2 rounded-lg bg-white border border-gray-200">

//                     {PORTAL_SETTINGS?.emp_details_edit &&
//                       <div className='flex justify-center item-center'>
//                         <a href={`${FRONTEND_URL}/personaldetailss/${formData.user_detail}/`} className="" target="_blank" title="Edit Profile Details" rel="noopener noreferrer">
//                           <button
//                             className="flex items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer transition"
//                             onClick={() => setIsModalOpen(false)}
//                           >
//                             <UpdatePencil /> Edit Profile Details
//                           </button>
//                         </a>
//                       </div>
//                     }

//                     <div>
//                       <BankDetailsWithApprovalRequest
//                         code={emp_code}
//                         extra_close={() => setIsModalOpen(false)}
//                       />
//                     </div>
//                     {/* <div>
//                       {appData === null ?
//                         <UploadAppraisalDetailsByEmployee />
//                         : null
//                       }
//                     </div>
//                     <div>
//                       {appData !== null && appData.hod_update_datetime === null && appData.admin_update_datetime === null ?
//                         <EditAppraisalDetailsByEmployee i={appData} />
//                         : null
//                       }
//                     </div> */}
//                     <div>
//                       {appData?.status === "no_form" && appData?.setup_id ? (
//                         <UploadAppraisalDetailsByEmployee i={appData} setupId={appData.setup_id} />
//                       ) : null}
//                     </div>

//                     <div>
//                       {appData?.status === "has_form" &&
//                         !appData.data.hod_update_datetime &&
//                         !appData.data.admin_update_datetime ? (
//                         <EditAppraisalDetailsByEmployee i={appData.data} />
//                       ) : null}
//                     </div>

//                     <div className=''>
//                       {appData?.status === "has_form" &&
//                         (appData.data.hod_update_datetime || appData.data.admin_update_datetime) ? (
//                         <>
//                           <ViewAppraisalDetailsByEmployee i={appData.data} />
//                         </>
//                       ) : null}
//                     </div>

//                     <div>
//                       {appData?.error === "No active quick appraisal form setup found for this sub-company." ? (
//                         <div className="error-message">
//                           {appData.error}
//                         </div>
//                       ) : null}
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//         <div className='user_inner2 font-weight400 '>
//           <div>
//             <h1 className='font-size-text'>Job Title</h1>
//             <p>{formData.designation_name}</p>
//           </div>
//           <div>
//             <h1 className='font-size-text'>Department</h1>
//             <p>{formData.department_name}</p>
//           </div>
//           <div>
//             <h1 className='font-size-text'>Business Unit</h1>
//             <p>{formData.division_name}</p>
//           </div>
//           <div>
//             <h1 className='font-size-text'>Reporting Person</h1>
//             <p>{formData.rh_name}
//               {/* <br />{formData.reporting_head} */}
//             </p>
//           </div>
//           <div>
//             <h1 className='font-size-text'>Emp no</h1>
//             <p>{formData.emp_code}</p>
//           </div>
//         </div>

//       </div>

//     </div >
//   )
// }

const Userdetailsmain = ({ email, emp_code }) => {
  const [formData, setFormData] = useState({});
  const [appraisalDataExist, setAppraisalDataExist] = useState(null);
  const [appraisalRating, setAppraisalRating] = useState(null);
  const [buffer, setBuffering] = useState(true);
  const { SUB_COMPANIES, SUPER_ADMIN, PORTAL_SETTINGS } = usePermission();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isoptionShow, setIsOptionShow] = useState(false);
  const [submittedAppraisal, setSubmittedAppraisal] = useState(null);
  const [profilePicError, setProfilePicError] = useState(false);
  const photoDropdownRef = useRef(null);
  const actionsDropdownRef = useRef(null);

  // const profilePicUrl = formData.profilepic ? `${IMAGE_URL}${formData.profilepic}` : null;

  const S3_PROFILE_PIC_BASE_URL =
    "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/";

  /**
   * Converts profilepic value from backend into a valid image URL.
   *
   * Supports:
   * - null / undefined
   * - empty string
   * - relative S3 path
   * - http:// URL
   * - https:// URL
   * - leading slash
   */
  const getProfilePicUrl = (profilePic) => {
    if (!profilePic || typeof profilePic !== "string") {
      return null;
    }

    const value = profilePic.trim();

    if (!value) {
      return null;
    }

    // Already a complete URL
    if (/^https?:\/\//i.test(value)) {
      return value;
    }

    // Remove leading slash so we don't create // after domain
    const cleanPath = value.replace(/^\/+/, "");

    return `${S3_PROFILE_PIC_BASE_URL}${cleanPath}`;
  };

  const profilePicUrl = getProfilePicUrl(formData.profilepic);

  const empStatusRaw = formData.employee_status || "unknown";
  const isStatusActive = empStatusRaw.toLowerCase() === "active";
  const statusColor = isStatusActive ? "#22C55E" : "#EF4444"; // Green if active, Red if not
  const statusText = empStatusRaw.charAt(0).toUpperCase() + empStatusRaw.slice(1); // Capitalizes first letter

  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const toggleDisplayOption = () => setIsOptionShow(!isoptionShow);

  const getUSerDetails = async () => {
    if (!emp_code) return;
    setBuffering(true);
    try {
      const res = await axios.get(`${BASE_URL}/wfm/ourcompanydetailsbyemp/${emp_code}/`);
      setFormData(res.data);
      setProfilePicError(false);
      // FIX: Only update session storage if the viewed profile belongs to the logged-in user
      const loggedInEmail = sessionStorage.getItem("email");
      const viewedUserEmail = res.data?.email || email;

      if (viewedUserEmail === loggedInEmail) {
        const profilePic = res.data?.profilepic || null;
        if (profilePic) {
          sessionStorage.setItem("profilepic", profilePic);
        } else {
          sessionStorage.removeItem("profilepic");
        }
        window.dispatchEvent(new CustomEvent("profilepic-updated", {
          detail: profilePic,
        }));
      }
    } catch (err) {
      handleAllError(err);
    } finally {
      setBuffering(false);
    }
  };

  // const getApprasalList = async () => {
  //   if (!emp_code) return;
  //   try {
  //     const res = await axios.get(`${BASE_URL}/wfm/quick-active-appraisaldetails-byemp/${emp_code}/`);
  //     setAppData(res.data);
  //   } catch (err) {
  //     console.log(err);
  //     setAppData(null);
  //   }
  // };

  const getApprasalList = async () => {
    if (!emp_code) return;
    try {
      const res = await axios.get(`${BASE_URL}/wfm/employee-appraisal-action-status/${emp_code}/`);
      setAppraisalDataExist(res.data);
    } catch (err) {
      console.log(err);
      setAppraisalDataExist(null);
    }
  };


  const getEmployeeAppraisalRating = async () => {
    if (!emp_code) return;
    try {
      const res = await axios.get(`${BASE_URL}/wfm/employee-appraisal-rating-by-employee/${emp_code}/`);
      setAppraisalRating(res.data);
    } catch (err) {
      console.log(err);
      setAppraisalRating(null);
    }
  };



  useEffect(() => {
    if (emp_code) {
      getUSerDetails();
      getApprasalList();
      getEmployeeAppraisalRating();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emp_code]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // FIX: If the click happens inside ANY modal, ignore it and do nothing.
      // (Adjust '.modal-content' if your custom modals use a different base class name)
      if (
        event.target.closest('.modal-content') ||
        event.target.closest('.modal-dialog') ||
        event.target.closest('.modal') ||
        event.target.closest('[role="dialog"]')
      ) {
        return;
      }

      // Close Photo Dropdown if click is outside
      if (photoDropdownRef.current && !photoDropdownRef.current.contains(event.target)) {
        setIsOptionShow(false);
      }

      // Close More Actions Dropdown if click is outside
      if (actionsDropdownRef.current && !actionsDropdownRef.current.contains(event.target)) {
        setIsModalOpen(false);
      }
    };

    // Use "mousedown" instead of "click" for better mobile/desktop reliability
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleDownload = async (e) => {
  //   e.preventDefault();
  //   if (typeof formData.profilepic === 'string') {
  //     const isFullUrl = formData.profilepic.startsWith('http://') || formData.profilepic.startsWith('https://');
  //     const picUrl = isFullUrl ? formData.profilepic : `https://cipl-aimantra.s3.ap-south-1.amazonaws.com/${formData.profilepic}`;

  //     try {
  //       const response = await fetch(picUrl);
  //       const blob = await response.blob();
  //       const link = document.createElement('a');
  //       link.href = URL.createObjectURL(blob);
  //       link.download = 'profile-pic.jpg';
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(link.href);
  //     } catch (error) {
  //       console.error("Download failed:", error);
  //     }
  //   }
  // };

  const handleDownload = async (e) => {
    e.preventDefault();

    const picUrl = getProfilePicUrl(formData.profilepic);

    if (!picUrl) {
      toast.error("Profile picture is not available.");
      return;
    }

    try {
      // Fetch image as blob
      const response = await fetch(picUrl, {
        method: "GET",
        mode: "cors",
        cache: "no-cache",
      });

      if (!response.ok) {
        throw new Error(
          `Unable to download profile picture. Status: ${response.status}`
        );
      }

      const blob = await response.blob();

      if (!blob || blob.size === 0) {
        throw new Error("Downloaded profile picture is empty.");
      }

      // Try to get original filename
      let fileName = "profile-pic";

      try {
        const url = new URL(picUrl);
        const pathName = decodeURIComponent(url.pathname);
        const originalName = pathName.split("/").pop();

        if (originalName) {
          fileName = originalName;
        }
      } catch (error) {
        console.warn("Unable to extract original filename:", error);
      }

      // If filename doesn't have extension, determine it from blob type
      if (!/\.[a-z0-9]+$/i.test(fileName)) {
        const extensionMap = {
          "image/jpeg": ".jpg",
          "image/jpg": ".jpg",
          "image/png": ".png",
          "image/webp": ".webp",
          "image/gif": ".gif",
          "image/svg+xml": ".svg",
        };

        const extension = extensionMap[blob.type] || ".jpg";

        fileName += extension;
      }

      // Create temporary blob URL
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = blobUrl;
      link.download = fileName;
      link.style.display = "none";

      document.body.appendChild(link);

      // Trigger browser download
      link.click();

      document.body.removeChild(link);

      // IMPORTANT:
      // Don't revoke immediately.
      // Give browser enough time to start download.
      setTimeout(() => {
        window.URL.revokeObjectURL(blobUrl);
      }, 1000);

    } catch (error) {
      console.error("Profile picture download failed:", error);

      /*
       * Fallback:
       * If S3/CORS blocks fetch, open image in a new tab
       * instead of silently failing.
       */
      try {
        window.open(picUrl, "_blank", "noopener,noreferrer");
      } catch (fallbackError) {
        console.error("Unable to open profile picture:", fallbackError);

        toast.error(
          "Unable to download profile picture. Please try again."
        );
      }
    }
  };

  const DeleteProfilePicture = async () => {
    const loadingToastId = toast.loading("Loading: Please wait...");
    try {
      let res = await axios.put(`${BASE_URL}/userdata/userdata/${email}/`, { profilepic: null });
      if (res.status === 200 || res.status === 201) {
        setProfilePicError(false);
        await getUSerDetails();
        toast.success("Profile picture deleted successfully!");
        setIsOptionShow(false);
      }
    } catch (err) {
      handleAllError(err, loadingToastId);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <div className='user_main-outer'>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

      <div className="profile-banner-wrapper">

        {/* NEW WRAPPER: Keeps Image and Details in a row on Tablets */}
        <div className="profile-banner-main-info">

          {/* LEFT: Profile Picture & Status */}
          <div className="profile-banner-left">
            <CustomImageModal customStyle>
              {/* {formData.profilepic ? (
                <img src={profilePicUrl} alt="profile" className="profile-banner-img" />
              ) : (
                <div className="profile-banner-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#e2e8f0' }}>
                  <UserDefaultLogo
                    user={{ name: formData.name, profilepic: formData.profilepic }}
                    customStyleforParent={"profile-banner-default-parent"}
                    customStyleforChild={"profile-banner-default-child"}
                  />
                </div>
              )} */}

              {profilePicUrl && !profilePicError ? (
                <img
                  src={profilePicUrl}
                  alt={`${formData.name || "Employee"} profile`}
                  className="profile-banner-img"
                  onError={() => setProfilePicError(true)}
                />
              ) : (
                <div
                  className="profile-banner-img"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#e2e8f0",
                  }}
                >
                  <UserDefaultLogo
                    user={{ name: formData.name, profilepic: formData.profilepic }}
                    customStyleforParent="profile-banner-default-parent"
                    customStyleforChild="profile-banner-default-child"
                  />
                </div>
              )}
            </CustomImageModal>
            <div
              className="profile-banner-status-dot"
              title={statusText}
              style={{ backgroundColor: statusColor }}
            ></div>
          </div>

          {/* MIDDLE: Details ONLY */}
          <div className="profile-banner-middle">
            <div className="profile-banner-name-row">
              <h1 className="profile-banner-name">{formData.name || "Employee Name"}</h1>
              <span
                className="profile-banner-active-badge"
                style={{
                  backgroundColor: isStatusActive ? 'rgba(255, 255, 255, 0.2)' : 'rgba(239, 68, 68, 0.8)',
                  color: '#fff'
                }}
              >
                {statusText}
              </span>
            </div>

            <div className="profile-banner-subtitle">
              {formData.designation_name} &bull; {formData.department_name}
            </div>

            {formData.location_name && (
              <div className="profile-banner-contact-row">
                <svg className="profile-banner-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                <span>{formData.location_name}</span>
              </div>
            )}

            {formData.user_detail && (
              <div className="profile-banner-contact-row">
                <svg className="profile-banner-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                <a href={`mailto:${formData.user_detail}`} style={{ color: 'inherit', textDecoration: 'none' }}>{formData.user_detail}</a>
              </div>
            )}
          </div>

        </div> {/* END OF MAIN INFO WRAPPER */}


        {/* RIGHT: Action Buttons (Top) & Stats Grid (Bottom) */}
        {/* On < 1024px screens, this whole block drops below the main info! */}
        <div className="profile-banner-right">

          {/* Action Buttons */}
          <div className="profile-banner-actions">

            {/* 1. Edit Profile */}
            {PORTAL_SETTINGS?.emp_details_edit && (
              <a href={`${FRONTEND_URL}/personaldetailss/${formData.user_detail}/?company_id=${sessionStorage.getItem("company_id") || "null"}`} target="_blank" rel="noopener noreferrer" className="profile-banner-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path></svg>
                <span className="btn-label-text">Edit Profile</span>
              </a>
            )}

            {/* 2. Change Photo Dropdown */}
            <div style={{ position: 'relative' }}>
              <button className="profile-banner-btn" onClick={toggleDisplayOption}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle></svg>
                <span className="btn-label-text">Change Photo</span>
              </button>

              {isoptionShow && (
                <div className="profile-banner-dropdown right-aligned" ref={photoDropdownRef}>
                  <ProfileUploadModal extra_close={() => setIsOptionShow(false)} pic={formData} getUSerDetails={getUSerDetails} pre_options={true} />
                  {/* {formData.profilepic && ( */}
                  {profilePicUrl && (
                    <>
                      <div className="flex items-center gap-2 p-2 rounded-md hover:bg-gray-100 cursor-pointer" onClick={handleDownload}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                        Download
                      </div>
                      <div className="flex items-center gap-2 p-2 rounded-md hover:bg-gray-100 cursor-pointer text-red-600" onClick={DeleteProfilePicture}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                        Delete
                      </div>
                    </>
                  )}
                </div>
              )}
            </div>

            {/* 3. More Actions Dropdown */}
            <div style={{ position: 'relative' }} ref={actionsDropdownRef}>
              <button className="profile-banner-btn" onClick={toggleModal}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle></svg>
                <span>More</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"></polyline></svg>
              </button>

              {isModalOpen && (
                <div className="profile-banner-dropdown right-aligned">
                  <div>
                    <BankDetailsWithApprovalRequest code={emp_code} extra_close={() => setIsModalOpen(false)} />
                  </div>
                  {/* <div>
                    {appData?.status === "no_form" && appData?.setup_id && (
                      <UploadAppraisalDetailsByEmployee i={appData} setupId={appData.setup_id} onSuccess={getApprasalList} />
                      // Employee view (list me row iterate karte waqt)
                      // <AppraisalRatingModal i={emp} ratingPeriod={setupId} subCompanyId={subCompanyId} role="EMPLOYEE" onSuccess={refetchList} />

                      // // RH / HOD / Admin view - sirf role change
                      // <AppraisalRatingModal i={emp} ratingPeriod={i.rating_period} subCompanyId={subCompanyId} role="RH" onSuccess={getDepartmentAppraisalData} />


                    )}
                  </div>
                  <div>
                    {appData?.status === "has_form" && !appData.data.hod_update_datetime && !appData.data.admin_update_datetime && (
                      <EditAppraisalDetailsByEmployee i={appData.data} onSuccess={getApprasalList} />
                      // <AppraisalRatingModal
                      //   i={appData}
                      //   viewerRole="employee"
                      //   triggerLabel="Self Appraisal"
                      //   triggerClassName="update-svg"
                      //   submitUrl={`${BASE_URL}/wfm/QuickAppresalUpdate/`}
                      //   submitMethod="put"
                      //   onSuccess={getApprasalList}
                      //   isFinalApprover={false}
                      // />
                    )}
                  </div> */}
                  {/* <div>
                    {!submittedAppraisal && (
                      <UploadAppraisalDetailsByEmployee
                        i={appData}
                        onSuccess={(submittedData) => setSubmittedAppraisal(submittedData)}
                      />
                    )}
                  </div>
                  <div>
                    {submittedAppraisal && (
                      <EditAppraisalDetailsByEmployee
                        ratingData={appraisalRating}
                        i={appData}
                        results={submittedAppraisal}
                        onSuccess={(updatedData) => setSubmittedAppraisal(updatedData)}
                      />
                    )}
                  </div> */}
                  <div>
                    {appraisalDataExist?.action_status === "post" && (
                      <UploadAppraisalDetailsByEmployee
                        i={appraisalDataExist}
                        onSuccess={() => {
                          getEmployeeAppraisalRating();
                          getApprasalList();
                        }}
                      />
                    )}

                    {appraisalDataExist?.action_status === "edit" && (
                      <EditAppraisalDetailsByEmployee
                        i={appraisalDataExist}
                        results={appraisalRating}
                        onSuccess={() => {
                          getEmployeeAppraisalRating();
                          getApprasalList();
                        }}
                      />
                    )}

                    {appraisalDataExist?.action_status === "view" && (
                      <ViewAppraisalDetailsByEmployee employeeCode={emp_code} />
                    )}
                  </div>

                  {appraisalDataExist?.status === null && (
                    <div className="text-red-500 text-sm p-2">
                      No active quick appraisal form setup found for this sub-company.
                    </div>
                  )}

                  {appraisalDataExist?.error && (
                    <div className="text-red-500 text-sm p-2">
                      {appraisalDataExist.error}
                    </div>
                  )}



                </div>
              )}
            </div>
          </div>

          {/* Stats Grid */}
          <div className="profile-banner-stats-grid">
            <div className="pb-stat-group">
              <span className="pb-stat-label">Employee ID</span>
              <span className="pb-stat-value">{formData.emp_code || "-"}</span>
            </div>
            <div className="pb-stat-group">
              <span className="pb-stat-label">Joining Date</span>
              <span className="pb-stat-value">
                {formData.joining_date ? formattedDateLong(formData.joining_date) : "-"}
              </span>
            </div>
            <div className="pb-stat-group">
              <span className="pb-stat-label">Department</span>
              <span className="pb-stat-value">{formData.department_name || "-"}</span>
            </div>
            <div className="pb-stat-group">
              <span className="pb-stat-label">Reporting To</span>
              <span className="pb-stat-value">{formData.rh_name || "-"}</span>
            </div>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Userdetailsmain;
